import BaseError from '../baseError.js';
var MissingDependencyErrorCode;
(function (MissingDependencyErrorCode) {
    MissingDependencyErrorCode["MISSING"] = "MISSING_DEPENDENCY_ERROR";
})(MissingDependencyErrorCode || (MissingDependencyErrorCode = {}));
export class MissingDependencyError extends BaseError {
    constructor(message, originalError) {
        super(MissingDependencyErrorCode.MISSING, message, originalError);
    }
}
//# sourceMappingURL=index.js.map